import { useEffect, useState } from 'react';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Users, Shield, User } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get('/admin/users').then(r => setUsers(r.data)).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const changeRole = async (uid, role) => {
    try { await api.put(`/admin/users/${uid}/role`, { role }); toast.success('Role mis a jour'); load(); }
    catch { toast.error('Erreur'); }
  };

  if (loading) return <div className="flex justify-center py-20"><div className="spin-gold w-8 h-8" /></div>;

  return (
    <div className="fade-in" data-testid="admin-users-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit' }}>Utilisateurs</h1>
        <Badge className="bg-[#D4AF37]/15 text-[#D4AF37]"><Users className="w-3 h-3 mr-1" /> {users.length}</Badge>
      </div>

      <div className="space-y-3">
        {users.map(u => (
          <div key={u.user_id} className="bg-[#121212] border border-white/5 rounded-xl p-4 flex items-center gap-4" data-testid={`user-${u.user_id}`}>
            <div className={`p-2 rounded-lg ${u.role === 'admin' ? 'bg-[#D4AF37]/10' : 'bg-white/5'}`}>
              {u.role === 'admin' ? <Shield className="w-4 h-4 text-[#D4AF37]" /> : <User className="w-4 h-4 text-[#A1A1AA]" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold">{u.name}</div>
              <div className="text-[10px] text-[#A1A1AA]">{u.email} {u.phone && `- ${u.phone}`}</div>
            </div>
            <div className="text-[10px] text-[#A1A1AA] hidden sm:block">
              {new Date(u.created_at).toLocaleDateString('fr-FR')}
            </div>
            <Select value={u.role} onValueChange={(v) => changeRole(u.user_id, v)}>
              <SelectTrigger className="w-28 bg-[#0A0A0A] border-white/10 rounded-lg h-8 text-xs" data-testid={`role-select-${u.user_id}`}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-[#121212] border-white/10">
                <SelectItem value="user">User</SelectItem>
                <SelectItem value="admin">Admin</SelectItem>
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
}
